import { useAuth } from "../context/AuthProvider";
import { useEffect, useState } from "react";
import { getCustomer } from "../apis/authApi";
import { getAllProducts } from "../apis/config";

const Order = () => {
  const { user } = useAuth();
  const [data, setData] = useState([]);
  const [expandedOrders, setExpandedOrders] = useState({});

  useEffect(() => {
    let productsList = [];

    getAllProducts()
      .then((res) => {
        productsList = res.data;
        if (user && user._id) {
          getCustomer(user._id)
            .then((res) => {
              setData(
                res.data.purchaseHistory.map((pur) => ({
                  order: pur.orderId,
                  date: pur.orderDate,
                  status: pur.status,
                  total:
                    parseInt(pur.paymentDetails.amount) +
                    parseInt(pur.paymentDetails.taxAmount) +
                    parseInt(pur.paymentDetails.shippingAmount),
                  products: pur.products.map((p) => {
                    const product = productsList.find((pd) => pd._id === p.product);
                    return {
                      product: product?.name||"",
                      quantity: p.quantity,
                      productImage: product?.images?.[0] || "",
                    };
                  }),
                  shippingAddress: pur.shippingAddress,
                  orderStatus: pur.orderStatus,
                }))
              );
            })
            .catch((err) => console.log(err));
        }
      })
      .catch((err) => console.log(err));
  }, [user?._id]);

  const toggleOrderDetails = (orderId) => {
    setExpandedOrders((prev) => ({
      ...prev,
      [orderId]: !prev[orderId],
    }));
  };

  return (
    <div className="w-full">
      <div className="p-5 w-full bg-gray-200">
        {/* Mobile Header */}
        <div className="flex justify-center items-center flex-col md:hidden">
          <h1 className="font-bold text-lg">Order</h1>
          <div className="text-sm text-gray-600 flex justify-center items-center gap-3">
            <span className="cursor-pointer">Home</span>/<span>Account</span>
          </div>
        </div>

        {/* Desktop Header */}
        <div className="hidden md:flex justify-between items-center">
          <h1 className="font-bold text-lg">Order</h1>
          <div className="text-sm text-gray-600 flex justify-end gap-2">
            <span className="cursor-pointer">Home</span>/<span>Account</span>
          </div>
        </div>
      </div>

      <div className="mt-5 px-5 py-5">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4">
          {data.map((order, index) => {
            const deliveryDate = new Date(order.date);
            deliveryDate.setDate(deliveryDate.getDate() + 7);

            const formattedDate = deliveryDate.toLocaleDateString("en-GB", {
              weekday: "long",
              day: "numeric",
              month: "long",
              year: "numeric",
            });
            return (
            <div
              key={index}
              className="border-[1px] border-gray-300 rounded-md p-4 shadow-sm bg-white"
            >
              {/* Order status and estimated delivery */}
              <div className="mb-3">
                <p className="text-xs text-gray-500 font-semibold uppercase">
                  Order Status:
                </p>
                <p className="text-base font-bold text-black">
                  {order.status.toUpperCase()}
                </p>
                <p className="text-sm text-green-600">
                  Estimated delivery{" "}
                  {formattedDate}
                </p>
              </div>

              {/* Product image */}
              {order.products[0]?.productImage && (
                <div className="mb-3">
                  <img
                    src={order.products[0].productImage}
                    alt="Product"
                    className="w-20 h-20 object-cover rounded"
                  />
                </div>
              )}

              {/* Order number and date */}
              <div className="mb-3 text-sm text-gray-700">
                <p>
                  <span className="font-medium">Order No.:</span> {order.order}
                </p>
                <p>
                  <span className="font-medium">Order Date:</span>{" "}
                  {new Date(order.date).toLocaleDateString()}
                </p>
              </div>

              {/* Buttons */}
              <div className="flex gap-2">
                <button
                  className="px-4 py-1 border border-black text-black text-sm"
                  onClick={() => toggleOrderDetails(order.order)}
                >
                  {expandedOrders[order.order] ? "HIDE DETAILS" : "VIEW ORDER"}
                </button>
                <button className="px-4 py-1 border border-black text-black text-sm">
                  CANCEL ORDER
                </button>
              </div>

              {/* Expanded Order Details */}
              {expandedOrders[order.order] && (
                <div className="mt-4 text-sm text-gray-700 border-t pt-4">
                  <h4 className="font-semibold mb-2">Order Details</h4>

                  {/* Product list */}
                  <div className="mb-2">
                    <p className="font-medium text-gray-800">Products:</p>
                    {order.products.map((product, i) => (
                      <div
                        key={i}
                        className="pl-2 flex gap-2 items-center my-1"
                      >
                        <img
                          src={product.productImage}
                          alt="Product"
                          className="w-10 h-10 object-cover rounded"
                        />
                        <span>Product : {product.product}</span>
                        <span>Qty: {product.quantity}</span>
                      </div>
                    ))}
                  </div>

                  {/* Shipping Address */}
                  <div className="mb-2">
                    <p className="font-medium text-gray-800">
                      Shipping Address:
                    </p>
                    <p>
                      {order.shippingAddress?.street},{" "}
                      {order.shippingAddress?.city},{" "}
                      {order.shippingAddress?.state} -{" "}
                      {order.shippingAddress?.pincode}
                    </p>
                  </div>

                  {/* Timeline */}
                  <div>
                    <p className="font-medium text-gray-800 mb-1">
                      Order Timeline:
                    </p>
                    <ol className="relative border-l border-gray-300 pl-4">
                      {order.orderStatus?.map((statusItem, idx) => (
                        <li key={idx} className="mb-4 ml-2">
                          <div className="absolute w-3 h-3 bg-blue-600 rounded-full -left-1.5 border border-white"></div>
                          <time className="block text-xs text-gray-400">
                            {new Date(
                              statusItem.timestamp
                            ).toLocaleString()}
                          </time>
                          <p className="text-sm font-medium capitalize">
                            {statusItem.status}
                          </p>
                          <p className="text-sm text-gray-600">
                            {statusItem.description}
                          </p>
                        </li>
                      ))}
                    </ol>
                  </div>
                </div>
              )}
            </div>
          )})}
        </div>
      </div>
    </div>
  );
};

export default Order;
